import { ComponentProps } from "../registry";
import { useBound, writePath } from "../helpers";
import { BoundBoolean, BoundValue } from "../../types";

export function CheckBox({ fields, scope }: ComponentProps) {
  const label = useBound<string>(fields.label as BoundValue, scope);
  const value = useBound<boolean>(fields.value as BoundValue, scope) ?? false;
  const path = (fields.value as BoundBoolean | undefined)?.path;

  return (
    <label className="a2-checkbox">
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => path && writePath(path, e.target.checked)}
      />
      {label && <span>{label}</span>}
    </label>
  );
}
